import axios from "axios";
import Button from "components/button/index.js";
import LoadingButton from "components/button/loading.js";
import ModalBody from "components/modal/components/body.js";
import ModalFooter from "components/modal/components/footer.js";
import Modalheader from "components/modal/components/header.js";
import Autorisationtravail from "components/modal/dataModal/data/modaljustify/identity/components/body/autorisationtravail";
import Selfie from "components/modal/dataModal/data/modaljustify/identity/components/body/selfie";
import useModal from "components/modal/useModal.js";
import UseContext from "hooks/useContext";
import usefetchdata from "hooks/usefetchdata";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useWindowDimensions from "../../../../../../hooks/useWindowDimensions";
import CheckFilesIdentity from "./components/body/checkFilesIdentity";
import Confirmationupdate from "./components/body/update/confirmationupdate.js";
import Footerbuttonupdate from "./components/body/update/footerbuttonupdate.js";
import Indicatorupdate from "./components/body/update/indicatorupdate.js";
import PiUpdate from "./components/body/update/piupdate.js";
import { convertPdfToImageIfNeeded } from "utils/pdfToImage";
const Modalidentitymodify = () => {
  const { tempWorkerData } = usefetchdata();
  const { refreshLoadWorker, language, isWebcamToUse, setIsWebcamToUse } =
    UseContext();
  const [formIndex, setFormIndex] = useState(1);
  const [nationality, setNationality] = useState("");
  const [forceNationality, setForceNationality] = useState(false);
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detectCaptureWebcam, setDetectCaptureWebcam] = useState(false);
  const { height, width } = useWindowDimensions();
  const { toggle } = useModal();

  const [pi, setPi] = useState({
    type: "",
    fileR: null,
    fileV: null,
    nationality: "",
  });
  const [selfie, setSelfie] = useState(null);
  const [visa, setVisa] = useState({
    type: "",
    fileR: null,
    fileV: null,
    nationality: "",
  });

  // EU nationality: identity + selfie only
  const elementsEU = [
    <Confirmationupdate
      key="confirmation"
      userData={tempWorkerData}
      setFormIndex={setFormIndex}
      nationality={nationality}
      forceNationality={forceNationality}
    />,
    <PiUpdate
      key="piupdate"
      pi={pi}
      setPi={setPi}
      check={check}
      setCheck={setCheck}
      formIndex={formIndex}
      nationality={nationality}
      setForceNationality={setForceNationality}
    />,
    <CheckFilesIdentity
      key="checkidentity"
      files={[pi.fileR, pi.fileV]}
    />,
    <Selfie
      key="selfie"
      setSelfie={setSelfie}
      setDetectCaptureWebcam={setDetectCaptureWebcam}
    />,
    <CheckFilesIdentity key="checkselfie" files={[selfie]} />,
  ];
  // Non-EU nationality: identity + selfie + visa (all together)
  const elementsNonEU = [
    <Confirmationupdate
      key="confirmation"
      userData={tempWorkerData}
      setFormIndex={setFormIndex}
      nationality={nationality}
      forceNationality={forceNationality}
    />,
    <PiUpdate
      key="piupdate"
      pi={pi}
      setPi={setPi}
      check={check}
      setCheck={setCheck}
      formIndex={formIndex}
      nationality={nationality}
      setForceNationality={setForceNationality}
    />,
    <CheckFilesIdentity
      key="checkidentity"
      files={[pi.fileR, pi.fileV]}
    />,
    <Selfie
      key="selfie"
      setSelfie={setSelfie}
      setDetectCaptureWebcam={setDetectCaptureWebcam}
    />,
    <CheckFilesIdentity key="checkselfie" files={[selfie]} />,
    <Autorisationtravail
      key="visa"
      setVisa={setVisa}
      visa={visa}
    />,
    <CheckFilesIdentity
      key="checkvisa"
      files={[visa.fileR, visa.fileV]}
    />,
  ];

  const effect1 = (f) =>
    f.identity?.validated === "1" && f.visa?.validated === "1";
  const effect2 = (f) => f.identity?.validated === "1";
  useEffect(() => {
    if (pi.nationality !== "" && pi.nationality !== nationality) {
      setNationality(pi.nationality);
    } else {
      if (effect2(tempWorkerData) || effect1(tempWorkerData)) {
        if (effect1(tempWorkerData)) {
          setNationality("NUE");
        } else {
          setNationality("UE");
        }
      } else {
        setFormIndex(1);
      }
    }
  }, [tempWorkerData, pi.nationality]);

  useEffect(() => {
    console.log(`📄 [Modal Identity Modify] Page actuelle: ${formIndex}`);
  }, [formIndex]);

  const m = async (formData, successMsg) => {
    setLoading(true);
    const idToastLoad = toast.loading("Envoi des fichiers en cours");
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}upload/files`,
        formData,
        {
          withCredentials: true,
        }
      );
      if (result.status === 201) {
        setLoading(false);
        setFormIndex(1);
        toast.update(idToastLoad, {
          render: "Fichiers uploadés",
          type: "success",
          autoClose: 3000,
          isLoading: false,
        });
        refreshLoadWorker();
        setForceNationality(nationality);
      } else {
        setLoading(false);
        toast.update(idToastLoad, {
          render: "Erreur d'envoi des fichiers",
          type: "error",
          autoClose: 3000,
          isLoading: false,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.update(idToastLoad, {
        render: "Erreur d'envoi des fichiers",
        type: "error",
        autoClose: 3000,
        isLoading: false,
      });
    }
  };
  // Check if non-EU nationality requires visa
  const isNonEU = nationality === "NUE" || pi.nationality === "NUE" || forceNationality === "NUE";

  // *Section onClick modify - Submit all identity group documents together
  const handleModifyIdentityGroup = async (e) => {
    e.preventDefault();
    if (!check) {
      toast.warning("Veuillez cocher l'attestation sur l'honneur");
      return;
    }
    
    if (pi.fileR === null || selfie === null) {
      toast.warning("Veuillez importer à la fois l'identité et le selfie");
      return;
    }
    
    if (pi.type === "CNI" && pi.fileV === null) {
      toast.warning("Veuillez importer le verso de la CNI");
      return;
    }

    // For non-EU: validate visa is also provided
    if (isNonEU) {
      if (visa.fileR === null) {
        toast.warning("Veuillez importer l'autorisation de travail");
        return;
      }
      if (visa.type === "Visa" && visa.fileV === null) {
        toast.warning("Veuillez importer le verso du visa");
        return;
      }
    }
    
    const token = localStorage.getItem("xsrfToken");
    const formData = new FormData();
    formData.append("token", token);
    
    // Convert PDFs to images if needed
    const identityRFile = await convertPdfToImageIfNeeded(pi.fileR);
    const selfieFile = await convertPdfToImageIfNeeded(selfie);
    
    const identityType = String(pi.type || "");
    formData.append("identityType", identityType);
    formData.append("identityR", identityRFile);
    formData.append("nationality", nationality);
    formData.append("selfie", selfieFile);

    // Add identity verso if CNI
    if (pi.type === "CNI") {
      const identityVFile = await convertPdfToImageIfNeeded(pi.fileV);
      formData.append("identityV", identityVFile);
    }

    // Add visa documents for non-EU nationalities
    if (isNonEU && visa.fileR) {
      const visaRFile = await convertPdfToImageIfNeeded(visa.fileR);
      formData.append("visaR", visaRFile);
      formData.append("visaType", visa.type);
      
      if (visa.type === "Visa" && visa.fileV) {
        const visaVFile = await convertPdfToImageIfNeeded(visa.fileV);
        formData.append("visaV", visaVFile);
      }
    }

    await m(formData, "Documents d'identité modifiés");
  };

  const isIdentityValid = (f) =>
    f.type !== "" &&
    (f.nationality !== "" || forceNationality) &&
    f.fileR !== "" &&
    f.fileR !== null;
  const isSelfieValid = (f) => f !== null && f !== "";
  const isVisaValid = (f) =>
    f.type !== "" &&
    f.fileR !== "" &&
    f.fileR !== null &&
    ((f.type === "Visa" && f.fileV !== "" && f.fileV !== null) || f.type === "RTS");

  const handleIndex = (e) => {
    if (formIndex < 1) setFormIndex(1);

    // Navigation between steps: allow to proceed if current step document is filled
    // Final validation (all documents together) happens only during submission
    if (
      (formIndex === 2 && isIdentityValid(pi) && check) || // Identity upload step: "Next" - check identity only
      (formIndex === 3) || // Identity verification step: "Next" - proceed to selfie upload
      (formIndex === 4 && isSelfieValid(selfie)) || // Selfie upload step: "Next" - check selfie only
      (formIndex === 5 && !isNonEU) || // Selfie verification (EU): final step handled by submit button
      (formIndex === 5 && isNonEU) || // Selfie verification (non-EU): proceed to visa
      (formIndex === 6 && isVisaValid(visa)) // Visa upload step: "Next" - check visa only
    ) {
      setFormIndex(formIndex + 1);
    } else {
      if (formIndex === 2 && !check)
        toast.warning("Veuillez cocher l'attestation sur l'honneur");
      else if (formIndex === 2)
        toast.warning("Veuillez remplir les champs de l'identité");
      else if (formIndex === 4)
        toast.warning("Veuillez importer le selfie");
      else if (formIndex === 6)
        toast.warning("Veuillez remplir les champs de l'autorisation de travail");
      else toast.warning("Veuillez remplir les champs");
    }
  };

  useEffect(() => {
    if (detectCaptureWebcam) {
      handleIndex();
      setDetectCaptureWebcam(false);
    }
  }, [detectCaptureWebcam]);

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {language.getValue("justify.m_identity_title_c")}
      </Modalheader>
      <ModalBody>
        <Indicatorupdate
          pi={pi}
          nationality={nationality}
          formIndex={formIndex}
        />
        {(isNonEU ? elementsNonEU : elementsEU).filter(
          (item, index) => index + 1 === formIndex
        )}
      </ModalBody>
      <ModalFooter>
        {loading ? (
          <LoadingButton size={"LG"} />
        ) : (
          <>
            <div className={"w-full"}>
              {formIndex === 4 && width <= 605 && (
                <div
                  className="text-yellow-500 underline cursor-pointer mr-auto mb-2"
                  onClick={() => {
                    setIsWebcamToUse(!isWebcamToUse);
                  }}
                >
                  {isWebcamToUse ? "Importer un fichier" : "Prendre une photo"}
                </div>
              )}
              <div
                className={
                  "flex items-center justify-end rounded-b gap-4 w-full"
                }
              >
                {formIndex === 1 ? null : (
                  <>
                    {formIndex === 4 && width > 605 && (
                      <div
                        className="text-yellow-500 underline cursor-pointer mr-auto"
                        onClick={() => {
                          setIsWebcamToUse(!isWebcamToUse);
                        }}
                      >
                        {isWebcamToUse
                          ? "Importer un fichier"
                          : "Prendre une photo"}
                      </div>
                    )}
                    <Button
                      size={"LG"}
                      color={"SECONDARY"}
                      onClick={() => {
                        setFormIndex(1);
                      }}
                    >
                      Annuler la modification
                    </Button>
                  </>
                )}
                <Footerbuttonupdate
                  formIndex={formIndex}
                  pi={pi.nationality}
                  nationality={nationality}
                  isNonEU={isNonEU}
                  oC1={toggle}
                  oC2={handleModifyIdentityGroup}
                  oC3={handleIndex}
                />
              </div>
            </div>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default Modalidentitymodify;
